import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { data } from '../../evn/evn'; // Ensure correct path
import Sidebar from '../AdminComponents/SideBar';
import styles from './OpponentDetailsManagement.module.css'; // Ensure path matches your CSS file structure

const OpponentDetailsManagement = () => {
  const [opponentDetails, setOpponentDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('id');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOpponentDetails = async () => {
      const ip = data.evn; // Ensure 'env' is correct
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/.admin');
        return false;
    }
      

      try {
        const response = await axios.get(`${ip}/admin/opponent-details`, {
          headers: { 'x-auth-token': token },
        });
        setOpponentDetails(response.data.opponentDetails);
        setSearchResults(response.data.opponentDetails);
      } catch (error) {
        console.error("There was an error fetching the opponent details:", error);
      }
    };

    fetchOpponentDetails();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (!event.target.value) {
      setSearchResults(opponentDetails);
    } else {
      const filteredOpponentDetails = opponentDetails.filter(detail => {
        switch (searchType) {
          case 'id':
            return detail.id.toString().includes(event.target.value);
          case 'userId':
            return detail.user_id.toString().includes(event.target.value);
          case 'caseId':
            return detail.case_id.toString().includes(event.target.value);
          default:
            return true;
        }
      });
      setSearchResults(filteredOpponentDetails);
    }
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchTerm('');
    setSearchResults(opponentDetails);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchTerm) {
      const exactMatchDetails = opponentDetails.filter(detail => {
        switch (searchType) {
          case 'id':
            return detail.id.toString() === searchTerm;
          case 'userId':
            return detail.user_id.toString() === searchTerm;
          case 'caseId':
            return detail.case_id.toString() === searchTerm;
          default:
            return false;
        }
      });
      setSearchResults(exactMatchDetails);
    }
  };

  return (
    <>
      <Sidebar />
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <select
            className={styles.searchTypeSelect}
            value={searchType}
            onChange={handleSearchTypeChange}
          >
            <option value="id">Search by ID</option>
            <option value="userId">Search by User ID</option>
            <option value="caseId">Search by Case ID</option>
          </select>
          <input
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className={styles.searchInput}
          />
        </div>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableRow}>
              <th className={styles.tableHeader}>ID</th>
              <th className={styles.tableHeader}>User ID</th>
              <th className={styles.tableHeader}>Case ID</th>
              <th className={styles.tableHeader}>Client Designation</th>
              <th className={styles.tableHeader}>Opponent Party Name</th>
              <th className={styles.tableHeader}>Lawyer Name</th>
              <th className={styles.tableHeader}>Mobile No</th>
              <th className={styles.tableHeader}>Email ID</th>
              
            </tr>
          </thead>
          <tbody>
            {searchResults.map((detail) => (
              <tr key={detail.id} className={styles.tableRow}>
                <td className={styles.tableCell}>{detail.id}</td>
                <td className={styles.tableCell}>{detail.user_id}</td>
                <td className={styles.tableCell}>{detail.case_id}</td>
                <td className={styles.tableCell}>{detail.clientDesignation}</td>
                <td className={styles.tableCell}>{detail.opponentPartyName}</td>
                <td className={styles.tableCell}>{detail.lawyerName}</td>
                <td className={styles.tableCell}>{detail.mobileNo}</td>
                <td className={styles.tableCell}>{detail.emailId}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OpponentDetailsManagement;
